import React, { Component } from 'react';

import { Router, IndexRoute, Route } from 'react-router';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import TouchButton from '../TouchButton';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import MenuItem from 'react-bootstrap/lib/MenuItem';

import Immutable from 'immutable';
import {firebaseRoot} from '../../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import TouchLink from '../../components/TouchLink';


const PageMenu = React.createClass({
    mixins: [ReactFireMixin],

    contextTypes: {
        history: React.PropTypes.object.isRequired
    },

    getInitialState() {
        return {user: null};
    },

    signOut() {
        this.context.history.pushState(null, '/', null);
        firebaseRoot.unauth();
    },

    render() {
        const user = this.state.user;
        {
            if (user) {
                return (
                    <ButtonToolbar>
                        <TouchButton bsStyle="link"><Glyphicon glyph="question-sign"/></TouchButton>
                        <Dropdown id="nav-dropdown" pullRight>
                            <Dropdown.Toggle bsClass="btn btn-link">
                                <Glyphicon glyph="menu-hamburger"/>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <MenuItem header>{user.email}</MenuItem>
                                <MenuItem divider />
                                <MenuItem onClick={this.signOut}>Sign out</MenuItem>
                            </Dropdown.Menu>
                        </Dropdown>
                    </ButtonToolbar>
                );
            } else {
                return (
                    <TouchLink to="/login">Login</TouchLink>
                );
            }
        }

    }
});

export default PageMenu;


/** WEBPACK FOOTER **
 ** ./src/components/PageMenu/PageMenu.js
 **/